document.querySelectorAll('.media-gallery').forEach(function (root) {
  var tiles = Array.prototype.slice.call(root.querySelectorAll('.media-gallery__tile'));
  var lightbox = root.querySelector('.media-gallery__lightbox');
  if (!tiles.length || !lightbox) return;

  var stage = lightbox.querySelector('[data-mg-stage]');
  var track = lightbox.querySelector('[data-mg-track]');
  var counter = lightbox.querySelector('[data-mg-counter]');
  var caption = lightbox.querySelector('[data-mg-caption]');
  var toast = lightbox.querySelector('[data-mg-toast]');
  var zoomBtn = lightbox.querySelector('[data-mg-zoom]');
  var fullscreenBtn = lightbox.querySelector('[data-mg-fullscreen]');
  var shareBtn = lightbox.querySelector('[data-mg-share]');
  var closeBtn = lightbox.querySelector('[data-mg-close]');
  var prevBtn = lightbox.querySelector('[data-mg-prev]');
  var nextBtn = lightbox.querySelector('[data-mg-next]');

  var current = 0;
  var toastTimer;

  // Build one slide per tile; the track is repositioned to center the active slide.
  var slideEls = tiles.map(function (tile, i) {
    var srcImg = tile.querySelector('img');
    var slide = document.createElement('div');
    slide.className = 'media-gallery__lb-slide';
    var img = document.createElement('img');
    img.src = srcImg ? (srcImg.currentSrc || srcImg.src) : '';
    img.alt = srcImg ? srcImg.alt : '';
    slide.appendChild(img);
    slide.addEventListener('click', function () {
      if (i === current) toggleZoom();
      else { current = i; updateTrack(); }
    });
    track.appendChild(slide);
    return slide;
  });

  function slideSize() {
    return {
      w: Math.min(stage.clientWidth * 0.7, 860),
      h: stage.clientHeight
    };
  }

  function updateTrack() {
    stage.classList.remove('is-zoomed');
    zoomBtn.classList.remove('is-active');
    var size = slideSize();
    slideEls.forEach(function (el, i) {
      el.style.width = size.w + 'px';
      el.style.height = size.h + 'px';
      el.classList.toggle('is-active', i === current);
    });
    var gap = 28; // 14px margin each side
    var offset = stage.clientWidth / 2 - (current * (size.w + gap) + size.w / 2);
    track.style.transform = 'translateX(' + offset + 'px)';
    counter.textContent = (current + 1) + ' / ' + tiles.length;
    caption.textContent = (slideEls[current].querySelector('img') || {}).alt || '';
  }

  function open(index) {
    current = index;
    lightbox.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    updateTrack();
  }

  function close() {
    lightbox.classList.remove('is-open');
    document.body.style.overflow = '';
    if (document.fullscreenElement) document.exitFullscreen().catch(function () {});
  }

  function prev() { current = (current - 1 + tiles.length) % tiles.length; updateTrack(); }
  function next() { current = (current + 1) % tiles.length; updateTrack(); }

  function toggleZoom() {
    stage.classList.toggle('is-zoomed');
    zoomBtn.classList.toggle('is-active', stage.classList.contains('is-zoomed'));
  }

  function showToast(msg) {
    toast.textContent = msg;
    toast.classList.add('is-shown');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('is-shown'); }, 1800);
  }

  tiles.forEach(function (tile, i) {
    tile.addEventListener('click', function () { open(i); });
  });

  window.addEventListener('resize', function () {
    if (lightbox.classList.contains('is-open')) updateTrack();
  });

  closeBtn.addEventListener('click', close);
  prevBtn.addEventListener('click', prev);
  nextBtn.addEventListener('click', next);
  lightbox.addEventListener('click', function (e) { if (e.target === lightbox) close(); });
  zoomBtn.addEventListener('click', toggleZoom);

  fullscreenBtn.addEventListener('click', function () {
    if (!document.fullscreenElement) {
      (lightbox.requestFullscreen || function () {}).call(lightbox).catch(function () {});
    } else {
      document.exitFullscreen().catch(function () {});
    }
  });
  document.addEventListener('fullscreenchange', function () {
    fullscreenBtn.classList.toggle('is-active', !!document.fullscreenElement);
  });

  shareBtn.addEventListener('click', function () {
    var img = slideEls[current].querySelector('img');
    var url = (img && img.src) || window.location.href;
    var shareData = { title: (img && img.alt) || 'Photo', url: url };
    if (navigator.share) {
      navigator.share(shareData).catch(function () {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () { showToast('Link copied'); });
    } else {
      showToast('Sharing not supported');
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!lightbox.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowLeft') prev();
    if (e.key === 'ArrowRight') next();
  });

  // Swipe to move between images (touch devices)
  var touchStartX = null;
  var touchStartY = null;
  stage.addEventListener('touchstart', function (e) {
    if (stage.classList.contains('is-zoomed')) return;
    var t = e.changedTouches[0];
    touchStartX = t.clientX;
    touchStartY = t.clientY;
  }, { passive: true });

  stage.addEventListener('touchend', function (e) {
    if (touchStartX === null) return;
    var t = e.changedTouches[0];
    var dx = t.clientX - touchStartX;
    var dy = t.clientY - touchStartY;
    touchStartX = null;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
      if (dx > 0) prev(); else next();
    }
  }, { passive: true });
});